import React from 'react';
import SellerRatingBlock from '../seller-avatar-block/index';
import SellerContactBlock from '../seller-contact-block';
import SellerActionsBlock from '../seller-actions-block';
import { SellerInfoBlockContainer } from '../../app.style';
import SellerBuyBlock from '../seller-buy-block';

const SellerInfoBlock: React.FC<Props> = ({
    isMobileCardsLayout,
    isPurchaseAvailable,
    setIsBuyerProtectionOpen,
}) => {
    return (
        <SellerInfoBlockContainer
            isMobileCardsLayout={isMobileCardsLayout}
            className="seller-info-block-container"
            data-q="reply-box-2"
        >
            {isPurchaseAvailable && !isMobileCardsLayout && (
                <SellerBuyBlock
                    isMobileCardsLayout={isMobileCardsLayout}
                    setIsBuyerProtectionOpen={setIsBuyerProtectionOpen}
                />
            )}
            <SellerRatingBlock />
            <div className="seller-contact">
                <SellerContactBlock isPurchaseAvailable={isPurchaseAvailable} />
                <SellerActionsBlock />
            </div>
        </SellerInfoBlockContainer>
    );
};

interface Props {
    isMobileCardsLayout: boolean;
    isPurchaseAvailable?: boolean;
    setIsBuyerProtectionOpen?: (isOpen: boolean) => void;
}

export default SellerInfoBlock;
